import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NotifyProvider, useNotify } from './context/NotifyContext';
import { WalletProvider } from './context/WalletContext';
import { ContractProvider } from './context/ContractContext';

import Navbar from './components/layout/Navbar';
import Sidebar from './components/layout/Sidebar';
import Footer from './components/layout/Footer';
import Notification from './components/common/Notification';
import WrongNetworkBanner from './components/layout/WrongNetworkBanner';
import RequireRegistered from './components/common/RequireRegistered';
import RequireAdmin from './components/common/RequireAdmin';

import Home from './pages/Home';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Invest from './pages/Invest';
import Team from './pages/Team';
import Rewards from './pages/Rewards';
import History from './pages/History';
import Admin from './pages/Admin';

function ProtectedShell({ children }) {
  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  );
}

function Shell() {
  const { notify } = useNotify();

  return (
    <WalletProvider onNotify={notify}>
      <ContractProvider>
        <BrowserRouter>
          <div className="grid-bg" />
          <div className="app">
            <Navbar />
            <WrongNetworkBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />

              <Route path="/dashboard" element={
                <RequireRegistered><ProtectedShell><Dashboard /></ProtectedShell></RequireRegistered>
              } />
              <Route path="/invest" element={
                <RequireRegistered><ProtectedShell><Invest /></ProtectedShell></RequireRegistered>
              } />
              <Route path="/team" element={
                <RequireRegistered><ProtectedShell><Team /></ProtectedShell></RequireRegistered>
              } />
              <Route path="/rewards" element={
                <RequireRegistered><ProtectedShell><Rewards /></ProtectedShell></RequireRegistered>
              } />
              <Route path="/history" element={
                <RequireRegistered><ProtectedShell><History /></ProtectedShell></RequireRegistered>
              } />

              <Route path="/admin" element={
                <RequireAdmin><ProtectedShell><Admin /></ProtectedShell></RequireAdmin>
              } />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
            <Notification />
          </div>
        </BrowserRouter>
      </ContractProvider>
    </WalletProvider>
  );
}

export default function App() {
  return (
    <NotifyProvider>
      <Shell />
    </NotifyProvider>
  );
}
